import moment from 'moment'
import store from '../store'
import JSEncrypt from '../assets/js/jsencrypt.min.js'

/* 
  配置moment插件
 */
moment.locale('zh-cn')
export {moment}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
  return store.state.user.userPermissions.indexOf(key) !== -1
}

/* 
  密码通过RSA方式加密
 */
const encrypt = new JSEncrypt()
if (store.state.common.publicKey) encrypt.setPublicKey(store.state.common.publicKey)
export {encrypt}

/* 
  重置组件高度
 */
export function pageResize(o) {
  // 设置表格高度
  let sbHeight = o.$refs.searchBar.$el.clientHeight
  o.$refs.tableDetail.$el.style.height = "calc(100vh - " + (sbHeight + 210) + "px)"
  if (o.$refs.searchBar.$el.scrollHeight > sbHeight) {
    o.searchToggle = 1
  }
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}